module.exports = __webpack_public_path__ + "img/23E9.7b814adf.svg";